import { Box, Flex, Text } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { Col, Row } from "antd";
import Field from "components/Input/Field/index";
import DefaultButton from "ui/components/Button/PrimaryButton";
import SelectCnae from "ui/components/Input/SelectCnae";
import SelectClassificacaoTributaria from "ui/components/Input/SelectClassificacaoTributaria";
import SelectNaturezaJuridica from "ui/components/Input/SelectNaturezaJuridica";
import { FornecedorTributacao } from "core/features/fornecedores/typings/index";
import usePutTributacao from "features/fornecedores/hooks/usePutTributacao";
import useGetTributacao from "core/features/fornecedores/hooks/useGetTributacao";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { useEffect } from "react";
import { useLoading } from "components/GlobalLoading";
import SelectClassificacaoServicoPrestado from "components/Input/SelectClassificacaoServicoPrestado/index";
import OutlineButton from "ui/components/Button/OutlineButton";
import history from "infra/helpers/history";

interface TributacaoProps {
  id?: string;
}

function Tributacao({ id }: TributacaoProps) {
  const { mutate: handleSave, isLoading: isSaveLoading } = usePutTributacao(id);
  const { data, isLoading, isFetching } = useGetTributacao(id);

  const { control, handleSubmit, reset } = useForm<FornecedorTributacao>({});

  const onSubmit = async (data: FornecedorTributacao) => {
    handleSave(data, {
      onError: (err) => {
        showErrorAxios(err);
      },
      onSuccess: () => {
        showSuccess();
      },
    });
  };

  useEffect(() => {
    if (data) {
      reset(data);
    }
  }, [data, reset]);

  useLoading(isLoading || isFetching);

  return (
    <>
      <form onSubmit={() => handleSubmit(onSubmit)()}>
        <Text mb="16px" fontSize="18px">
          Tributação
        </Text>
        <Box as={Row} gutter={16} mb="32px">
          <Box as={Col} md={12}>
            <Field
              label="CNAE"
              control={control}
              name="cnaeId"
              render={({ field }) => <SelectCnae {...field} />}
            />
          </Box>

          <Box as={Col} md={12}>
            <Field
              label="Classificação Tributária"
              control={control}
              name="classificacaoTributariaId"
              render={({ field }) => (
                <SelectClassificacaoTributaria {...field} />
              )}
            />
          </Box>
        </Box>

        <Box as={Row} gutter={16} mb="32px">
          <Box as={Col} md={12}>
            <Field
              label="Natureza Jurídica"
              control={control}
              name="naturezaJuridicaId"
              render={({ field }) => <SelectNaturezaJuridica {...field} />}
            />
          </Box>
          <Box as={Col} md={12}>
            <Field
              label="Classificação do serviço prestado"
              control={control}
              name="classificacaoServicoPrestadoId"
              render={({ field }) => (
                <SelectClassificacaoServicoPrestado {...field} />
              )}
            />
          </Box>
        </Box>

        <Flex mt="16px" gap={4} justifyContent={"flex-end"}>
          <OutlineButton
            onClick={() => history.push(`/cadastros/fornecedores`)}
          >
            Voltar
          </OutlineButton>
          <DefaultButton
            onClick={handleSubmit(onSubmit)}
            isLoading={isSaveLoading}
            disabled={isSaveLoading}
          >
            Salvar
          </DefaultButton>
        </Flex>
      </form>
    </>
  );
}

export default Tributacao;
